export default "__VITE_ASSET__C4yjCsR1__"